/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function PuvTaggingContainer({
  getRequirementList, requirementList,
  getPermitTypeList, permitTypeList,
  updateApplicationRequirements,
}) {
  const [requirementListFormat, setRequirementListFormat] = useState([]);
  const [permitTypeListFormat, setPermitTypeListFormat] = useState([]);
  const [mode, setMode] = useState(0);
  const [formData, setFormData] = useState([]);
  const updateData = () => {
    getRequirementList({ display_all: 1 });
    getPermitTypeList({ name: 'PUV' }, () => { });
  };
  const formatFormData = () => {
    if (!_.isEmpty(permitTypeList)) {
      const list = permitTypeList.map(x => ({
        id: x.id,
        type: _.get(x, 'attributes.type', ''),
        requirement_list: _.get(x, 'included.applicationStatusRequirements', []).map(item => (item.attributes.requirement_id)),
      }));
      setPermitTypeListFormat(list);
      setFormData(list);
    }
  };

  // TEMPORARY FIX FOR MINOR BUG
  const handleSetMode = (num) => {
    setMode(num);
  };

  const handleToggle = (permitId, reqId) => () => {
    handleSetMode(1);
    const item = formData.find(x => (+x.id === +permitId)); // GET TARGET ROW
    const status = item.requirement_list.filter(x => (+x === +reqId)); // CHECK IF REQ VALUE EXIST IN ROW
    const valueAction = () => { // REMOVE OR ADD REQ_ID IN TARGET
      if (_.isEmpty(status)) {
        const a = _.concat(_.get(item, 'requirement_list', []), +reqId);
        return a;
      }
      const a = item.requirement_list.filter(x => (x !== +reqId));
      return a;
    };

    const newItem = { // REFORMAT TARGET WITH NEW VALUE
      ...item,
      requirement_list: valueAction(),
    };

    const reducedFormData = formData.filter(x => (+x.id !== +newItem.id)); // REMOVE TARGET FROM FORMDATA
    const newFormData = _.concat(reducedFormData, newItem); // REBIULD FORMDATA
    setFormData(newFormData);
  };

  const renderCheckbox = (permitId, reqId) => {
    const item = formData.find(x => (+x.id === +permitId));
    const status = item.requirement_list.filter(x => (+x === +reqId));
    return (
      <button type="button" className="btn-blank" onClick={handleToggle(permitId, reqId)}>
        {_.isEmpty(status)
          ? (<i className="far fa-square sp-icon-check-box" />)
          : (<i className="fas fa-check-square sp-icon-box" />)}
      </button>
    );
  };

  const handleSubmit = () => {
    handleSetMode(0);
    const args = formData.map(item => ({ application_status_id: item.id, requirement_id: item.requirement_list }));
    // console.log("sArgs:", args)
    args.map(item => updateApplicationRequirements(item));
  };

  const handleCancel = () => {
    setFormData(permitTypeListFormat);
    handleSetMode(0);
  };

  useEffect(() => {
    updateData();
  }, []);

  useEffect(() => {
    formatFormData();
  }, [permitTypeList]);

  useEffect(() => {
    if (!_.isEmpty(requirementList)) {
      const list = requirementList.map(x => ({
        requirement_id: _.get(x, 'id', ''),
        requirement_name: _.get(x, 'attributes.name'),
      }));
      setRequirementListFormat(list);
    }
  }, [requirementList]);

  return (
    <div className="card special-permit-tagging">
      <div className="card-content-listing">
        <div className="container-fluid p-10">
          <div className="row d-flex align-items-center">
            <div className="col-6">
              <h3 className='font-weight-bold'>Requirements Tagging</h3>
            </div>
            <div className="col-6 d-flex">
              {mode === 1 ? (
                <React.Fragment>
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold ml-auto px-4 mr-1"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-round font-weight-bold px-4"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </React.Fragment>
              ) : ''
              }
            </div>
          </div>
          <div className="mt-3 border-bottom-row" />

          {/* TABLE */}
          <div className="table-responsive mt-4 bg-sp">
            <table className="sp-css-table table table-striped table-sm table-light p-10">
              <thead className="sp-table-header">
                <tr>
                  {!_.isEmpty(permitTypeListFormat)
                    ? (
                      <React.Fragment>
                        <th scope="col" className="px-1">Requirement Types</th>
                        {permitTypeListFormat.map(item => (
                          <th scope="col" className="px-1" key={item.id}><div className="w-100 text-center">{item.type || ''}</div></th>
                        ))}
                      </React.Fragment>
                    ) : <th scope="col">Requirement Types</th>}
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(requirementListFormat)
                  ? (
                    <React.Fragment>
                      {requirementListFormat.map(item => (
                        <tr className="top-border" key={item.requirement_id}>
                          <td className="font-weight-bold py-3">{item.requirement_name}</td>
                          {permitTypeListFormat.map(x => (
                            <td className="py-3" key={x.id}><div className="w-100 text-center">{renderCheckbox(x.id, item.requirement_id)}</div></td>
                          ))}
                        </tr>
                      ))}
                    </React.Fragment>
                  ) : <tr />}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

PuvTaggingContainer.propTypes = {
  getPermitTypeList: PropTypes.instanceOf(Function).isRequired,
  permitTypeList: PropTypes.instanceOf(Array).isRequired,

  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  requirementList: PropTypes.instanceOf(Array).isRequired,

  updateApplicationRequirements: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permitTypeList: _.get(api, `${c.GET_PERMIT_TYPE_LIST}.list`) || [],
  requirementList: _.get(api, `${c.GET_REQUIREMENT_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);

export default enhance(PuvTaggingContainer);
